const __DEV__ = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
export const URL = __DEV__ ? 'http://localhost:3001/' : 'https://um-hilal.herokuapp.com/';
// export const URL = 'https://um-hilal.herokuapp.com/';

export const endpoints = {
  root: () => ['GET', URL],
  loginWithGoogle: () => ['POST', `${URL}login-with-google`],
  getUsers: () => ['GET', `${URL}api/users`],
  getUser: id => ['GET', `${URL}api/user/${id}`],
  deleteUser: id => ['DELETE', `${URL}api/user/${id}`],
  approveUser: id => ['POST', `${URL}api/user/${id}`],
  updateUser: id => ['POST', `${URL}api/user/${id}`],
  getHilals: () => ['GET', `${URL}api/hilal`],
  getHilal: id => ['GET', `${URL}api/hilal/${id}`],
  newHilal: () => ['POST', `${URL}api/hilal`],
};
